<span mat-dialog-title>{{ data }}</span>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-raised-button
    cdkFocusInitial
    color="primary"
    mat-dialog-close
  >
    {{ "select_Case_Dialog.OK" | translate }}
  </button>
</mat-dialog-actions>
